document.addEventListener('DOMContentLoaded', function () {
    initializeMobileMenu();

    function initializeMobileMenu() {
        const offCanvasBtn = document.getElementById('off-canvas-btn');
        const mobileMenu = document.getElementById('mobile-menu');
        const mobileMenuClose = document.getElementById('mobile-menu-close');
        const menuLinks = document.querySelectorAll('#mobile-menu-nav a');

        if (!offCanvasBtn || !mobileMenu || !mobileMenuClose) {
            return;
        }

        function openMenu() {
            mobileMenu.classList.add('open-menu');
        }

        function closeMenu() {
            mobileMenu.classList.remove('open-menu');
        }

        offCanvasBtn.addEventListener('click', openMenu);
        mobileMenuClose.addEventListener('click', closeMenu);

        // Close menu when clicking on links
        menuLinks.forEach(link => {
            link.addEventListener('click', closeMenu);
        });

        // Close menu when clicking outside its area
        window.addEventListener('click', function(event) {
            if (!mobileMenu.contains(event.target) && !offCanvasBtn.contains(event.target)) {
                closeMenu();
            }
        });
    }
});

